import { render } from "./DefaultTour.vue?vue&type=template&id=34e1d4fc&ts=true"
import script from "./DefaultTour.vue?vue&type=script&lang=ts"
export * from "./DefaultTour.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__